/**
 * Actions para gerenciamento do estado de polling
 */

export class ToggleTurboMode {
  static readonly type = "[DonationPolling] Toggle Turbo Mode";
}

export class SetTurboMode {
  static readonly type = "[DonationPolling] Set Turbo Mode";
  constructor(public isTurbo: boolean) {}
}

export class UpdateLastPoll {
  static readonly type = "[DonationPolling] Update Last Poll";
}

export class StartPolling {
  static readonly type = "[DonationPolling] Start Polling";
}

export class StopPolling {
  static readonly type = "[DonationPolling] Stop Polling";
}
